/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown> }} Subtitle_Export_Event_OverlapInputs */

const en_subtitle_export_event_overlap = /** @type {(inputs: Subtitle_Export_Event_OverlapInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Event ${i?.index} overlaps with the previous event.
 Would you like to ABORT your export?`)
};

const fr_subtitle_export_event_overlap = /** @type {(inputs: Subtitle_Export_Event_OverlapInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`L'événement ${i?.index} chevauche l'événement précédent.

Souhaitez-vous annuler l'exportation ?`)
};

const de_subtitle_export_event_overlap = /** @type {(inputs: Subtitle_Export_Event_OverlapInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ereignis ${i?.index} überschneidet sich mit dem vorherigen Ereignis.
Möchten Sie Ihren Export abbrechen?`)
};

const it_subtitle_export_event_overlap = /** @type {(inputs: Subtitle_Export_Event_OverlapInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`L'evento ${i?.index} si sovrappone all'evento precedente.
Vuoi ANNULLARE l'esportazione?`)
};

const ru_subtitle_export_event_overlap = /** @type {(inputs: Subtitle_Export_Event_OverlapInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Событие ${i?.index} перекрывается с предыдущим событием.
Вы хотите ОТМЕНИТЬ экспорт?`)
};

const es_subtitle_export_event_overlap = /** @type {(inputs: Subtitle_Export_Event_OverlapInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`El evento ${i?.index} se superpone con el evento anterior.
¿Desea cancelar la exportación?`)
};

const zh_cn2_subtitle_export_event_overlap = /** @type {(inputs: Subtitle_Export_Event_OverlapInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`事件 ${i?.index} 与上一个事件重叠。

是否要中止导出？`)
};

const ja_subtitle_export_event_overlap = /** @type {(inputs: Subtitle_Export_Event_OverlapInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`イベント ${i?.index} は前のイベントと重複しています。
エクスポートを中止しますか?`)
};

const hi_subtitle_export_event_overlap = /** @type {(inputs: Subtitle_Export_Event_OverlapInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`इवेंट ${i?.index} पिछले इवेंट के साथ ओवरलैप हो रहा है।
क्या आप अपना निर्यात रद्द करना चाहेंगे?`)
};

const pt_pt2_subtitle_export_event_overlap = /** @type {(inputs: Subtitle_Export_Event_OverlapInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`O evento ${i?.index} se sobrepõe ao evento anterior.
Deseja CANCELAR a exportação?`)
};

/**
* | output |
* | --- |
* | "Event {index} overlaps with the previous event. Would you like to ABORT your export?" |
*
* @param {Subtitle_Export_Event_OverlapInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_event_overlap = /** @type {((inputs: Subtitle_Export_Event_OverlapInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Event_OverlapInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_event_overlap(inputs)
	if (locale === "de") return de_subtitle_export_event_overlap(inputs)
	if (locale === "it") return it_subtitle_export_event_overlap(inputs)
	if (locale === "ru") return ru_subtitle_export_event_overlap(inputs)
	if (locale === "es") return es_subtitle_export_event_overlap(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_event_overlap(inputs)
	if (locale === "ja") return ja_subtitle_export_event_overlap(inputs)
	if (locale === "hi") return hi_subtitle_export_event_overlap(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_event_overlap(inputs)
	return en_subtitle_export_event_overlap(inputs)
});